var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59094 6.5L13.0441 2.04687C13.2554 1.8359 13.3743 1.54962 13.3745 1.25099C13.3748 0.95237 13.2564 0.665874 13.0455 0.45453C12.8345 0.243185 12.5482 0.124305 12.2496 0.124041C11.951 0.123778 11.6645 0.242152 11.4531 0.453123L7 4.90625L2.54687 0.453123C2.33553 0.241779 2.04888 0.123047 1.75 0.123047C1.45111 0.123047 1.16447 0.241779 0.953123 0.453123C0.741779 0.664468 0.623047 0.951112 0.623047 1.25C0.623047 1.54888 0.741779 1.83553 0.953123 2.04687L5.40625 6.5L0.953123 10.9531C0.741779 11.1645 0.623047 11.4511 0.623047 11.75C0.623047 12.0489 0.741779 12.3355 0.953123 12.5469C1.16447 12.7582 1.45111 12.8769 1.75 12.8769C2.04888 12.8769 2.33553 12.7582 2.54687 12.5469L7 8.09375L11.4531 12.5469C11.6645 12.7582 11.9511 12.8769 12.25 12.8769C12.5489 12.8769 12.8355 12.7582 13.0469 12.5469C13.2582 12.3355 13.3769 12.0489 13.3769 11.75C13.3769 11.4511 13.2582 11.1645 13.0469 10.9531L8.59094 6.5Z",
    fill: "#74758C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c6cadeea090d9fb1623807a2d3a68b0f.svg";
export { ForwardRef as ReactComponent };